export const BACKEND_HOST = 'https://personality-compatibilty.herokuapp.com';
// export const BACKEND_LOCAL_HOST = 'http://localhost:5000';

const header = {
    "accepts": "application/json",
    "Content-Type": "application/json"
};

export const submitSurvey = async (postDetails) => {
    const postSurveyAPI = BACKEND_HOST + '/survey/submit-answers';
    const response = await fetch(postSurveyAPI, {
        method: 'POST',
        headers: header,
        body: JSON.stringify(postDetails)
    }).then(res => res.json());

    return response;
};

export const getTotalResponseCount = async () => {
    const getTotalResponseAPI = BACKEND_HOST + '/survey/response-count';
    const response = await fetch(getTotalResponseAPI, {
        method: 'GET',
        headers: header
    });

    return response;
}

export const getCumulativeResult = async () => {
    const getCumulativeResultAPI = BACKEND_HOST + '/survey/cumulative-report';
    const response = await fetch(getCumulativeResultAPI, {
        method: 'GET',
        headers: header
    }).then(res => res.json());

    return response;
}

export const getAllUsers = async () => {
    const getAllUsersAPI = BACKEND_HOST + '/survey/get-all-users';
    const response = await fetch(getAllUsersAPI, {
        method: 'GET',
        headers: header
    }).then(res => res.json());

    return response;
}

export const deleteUser = async (id) => {
    const deleteUserAPI = BACKEND_HOST + `/survey/delete?id=${id}`;
    const response = await fetch(deleteUserAPI, {
        method: 'DELETE',
        headers: header
    }).then(res => res.json());

    return response;
}